<fcom-modal
  class="continue-modal"
  [title]="(contentCollection$ | async)?.teaserTitle"
  [buttons]="ModalButtons.CUSTOM"
  [(open)]="modalOpen"
  [fullHeight]="true"
  (close)="closeModal.emit()"
  data-testid="ticket-selection-continue-modal"
>
  <div class="pr-large" [class.highlighted-content]="showKoreaNotification" *ngIf="contentUrl$ | async">
    <cms-article-collection
      [content$]="contentCollection$"
      [aspectRatio$]="aspectRatio$"
      [useGrid]="false"
      [disableTeaserTitle]="true"
      [sectionWrapperClass]="''"
      [sectionClass]="''"
    >
    </cms-article-collection>
  </div>
  <div buttons>
    <fcom-button
      class="mr-xsmall-r"
      [text]="'ticketSelection.cancelBtn' | finLocalization"
      [theme]="ButtonTheme.LIGHT_SECONDARY_OUTLINE"
      [aria]="{ label: 'ticketSelection.cancelBtn' | finLocalization, role: 'button' }"
      (clickBtn)="closeModal.emit()"
      data-testid="ticket-selection-continue-modal-close"
    ></fcom-button>
    <fcom-button
      [text]="'actions.continue' | finLocalization"
      [aria]="{ label: 'actions.confirm' | finLocalization, role: 'button' }"
      (clickBtn)="confirm.emit()"
      data-testid="ticket-selection-continue-modal-continue"
    ></fcom-button>
  </div>
</fcom-modal>
